export enum ProjectEnvironment {
  LOCAL = 'local',
  SIT = 'sit',
  UAT = 'uat',
  PHASE3 = 'phase3',
  PROD = 'prod',
}
